import { Modal, Typography, Space, Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import { fixtureVolumeSummary } from '@/mocks/fixtures';

const { Title, Paragraph } = Typography;

export interface AboutModalProps {
  open: boolean;
  onClose: () => void;
}

/**
 * "About this prototype" modal (S1-T03 / FR-001 shell hardening).
 *
 * Triggered from the header user menu. The same content is mirrored on the
 * /about page route via the About.tsx component.
 */
export default function AboutModal({ open, onClose }: AboutModalProps) {
  const { t } = useTranslation('common');
  const scope = t('about.scope', { returnObjects: true }) as string[];
  const mocked = t('about.mocked', { returnObjects: true }) as string[];

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={t('about.title')}
      footer={null}
      width={640}
      destroyOnHidden
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <Paragraph type="secondary" style={{ marginBottom: 0 }}>
          {t('about.intro')}
        </Paragraph>

        <div>
          <Title level={5} style={{ marginBottom: 4 }}>
            {t('about.scopeTitle')}
          </Title>
          <ul style={{ paddingInlineStart: 20, margin: 0 }}>
            {Array.isArray(scope) &&
              scope.map((line, i) => (
                <li key={i} style={{ marginBottom: 4 }}>
                  {line}
                </li>
              ))}
          </ul>
        </div>

        <div>
          <Title level={5} style={{ marginBottom: 4 }}>
            {t('about.mockedTitle')}
          </Title>
          <ul style={{ paddingInlineStart: 20, margin: 0 }}>
            {Array.isArray(mocked) &&
              mocked.map((line, i) => (
                <li key={i} style={{ marginBottom: 4 }}>
                  {line}
                </li>
              ))}
          </ul>
        </div>

        <div>
          <Title level={5} style={{ marginBottom: 4 }}>
            {t('about.nextTitle')}
          </Title>
          <Paragraph style={{ marginBottom: 0 }}>{t('about.next')}</Paragraph>
        </div>

        <Divider style={{ margin: '8px 0' }} />

        <Space wrap size={12} style={{ fontSize: 12, color: 'rgba(0,0,0,0.45)' }}>
          <span>
            {fixtureVolumeSummary.projects} projects · {fixtureVolumeSummary.contracts} contracts
            · {fixtureVolumeSummary.employees} employees · {fixtureVolumeSummary.documents} documents
          </span>
        </Space>

        <Paragraph type="secondary" style={{ marginBottom: 0, fontSize: 12 }}>
          {t('about.credits')}
        </Paragraph>
      </Space>
    </Modal>
  );
}
